// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".backdrop .plyr--paused .plyr__video-wrapper:after,.backdrop picture:after{content:\"\";top:0;right:0;bottom:0;left:0;position:absolute;background:currentColor;opacity:var(--opacity);z-index:2;border-radius:0.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
